import AboutApartmentOptionsItem from './AboutApartmentOptionsItem';
import Vue, { CreateElement, VNode } from 'vue';
import { Component, Prop } from 'vue-property-decorator';
import { IApartmentOptions } from '@/types';
import './style.styl';

@Component({
  name: 'AboutApartmentOptions',
})
export default class AboutApartmentOptions extends Vue {
  @Prop({type: String, default: '' }) public readonly title!: string;
  @Prop({type: Array, default: () => [] }) public readonly options!: [];
  @Prop({type: Boolean, default: false }) public readonly isMobile!: boolean;

  private render(createElement: CreateElement) {

    const title: VNode = createElement('p', {
      class: 'p5',
    }, this.title);

    const line: VNode = createElement('div', { class: 'line'});

    return createElement('div', { class: 'apartment-options' },
    [
      title,
      line,
      createElement('div', { class: 'options-wrapper' },
        this.options.map((item: IApartmentOptions) => {
          return createElement(AboutApartmentOptionsItem, {
            props: {
              isMobile: this.isMobile,
              label: item.name,
            },
          });
        }),
      ),
    ]);
  }
}
